import { createFileRoute } from '@tanstack/react-router'
import { Nav } from '@/components/landing/Nav'
import { Hero } from '@/components/landing/Hero'
import { HowItWorks } from '@/components/landing/HowItWorks'
import { Features } from '@/components/landing/Features'
import { LocalModels } from '@/components/landing/LocalModels'
import { MagicLamp } from '@/components/landing/MagicLamp'
import { Download } from '@/components/landing/Download'
import { Faq } from '@/components/landing/Faq'
import { FinalCta } from '@/components/landing/FinalCta'
import { Footer } from '@/components/landing/Footer'

/** The desktop app's page. It was the home page until the studio took that place. */
export const Route = createFileRoute('/desktop')({ component: DesktopPage })

function DesktopPage() {
  return (
    <div id="top" className="min-h-screen overflow-x-clip bg-canvas font-sans text-ink">
      <Nav />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <LocalModels />
        <MagicLamp />
        <Download />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  )
}
